import Vue from 'vue/dist/vue.esm.js'
Vue.component 'user-report-involved-employee-row',
  template: JST['user_report_rows/involved_employee_row']()
  props: ['row']

  created: ->
    @updateRow = _.debounce(@updateRow, ReportRowConfig.wait)

  computed:
    rowId: ->
      "row-#{@row.id}"

  watch:
    row:
      handler: -> @updateRow()
      deep: true

  methods:
    updateRow: ->
      $.ajax
        dataType: 'JSON',
        url: "/project_partners/#{@row.project_partner_id}/involved_employee_rows/#{@row.id}"
        method: 'PUT'
        data: _.pick(@row, ['client_notes'])
        success: =>
          Helper.flashRow($(@$el), '#bfdf9f')
      @.$emit('update-row', @row)
